import { fetchProductListItems, fetchDefaultPeopleListItems, fetchPhoneForListPerson } from "./service";
import { fetchPeopleListItemsV2 } from "../Search/people/service";
import { message } from "antd";

const Model = {
    namespace: 'list',
    state: {
        productLists: {},
        peopleLists: {},
        defaultPeopleList: {
            items: [],
            pagination: {
                total: 0,
                page: 1,
                pageSize: 10
            }
        },
        selectedRows: []
    },
    effects: {
        *fetchProductListItems({ payload, callback }: any, { call, put }: any) {
            let response: Promise<any> = yield call(fetchProductListItems, payload.id);

            response = (response as any).map((item: any) => {
                return {
                    item_id: item?.id || null,
                    id: item?.product?.id || null,
                    product_id: item?.product?.id || null,
                    name: item?.product?.name || '',
                    packaging_type: item?.product?.packaging_type || '',
                    country_of_origin: item?.product?.country_of_origin || '',
                    category: item?.product?.category || '',
                    marketed_by: item?.product?.marketer?.name || '-',
                    marketer_employee_count: item?.product?.marketer?.team_size || '',
                    manufactured_by: item?.product?.manufacturer?.name || '-',
                    manufacturer_employee_count: item?.product?.manufacturer?.team_size || '',
                    countries_of_sale: item?.product?.countries_of_sale?.map((c: any) => c?.name || '').join(", ") || '',
                }
            })
            yield put({
                type: 'setProductListItems',
                payload: {
                    id: payload.id,
                    items: response
                }
            });

            if (callback) {
                callback(response);
            }
        },
        *fetchPeopleListItemsV2({ payload, callback }: any, { call, put }: any) {
            try {
                const response: any[] = yield call(fetchPeopleListItemsV2, payload.listId);

                console.log('response', response);
                
                yield put({
                    type: 'setPeopleListItems',
                    payload: {
                        id: payload.listId,
                        items: response
                    }
                });

                if (callback) {
                    callback(response);
                }
            } catch (error) {
                console.error('Error fetching people list items:', error);
                if (callback) {
                    callback([]);
                }
            }
        },
        *fetchDefaultPeopleListItems({ payload, callback }: any, { call, put }: any): Generator<any, void, any> {
            try {
                const { page = 1, pageSize = 10 } = payload || {};
                
                // Ensure page and pageSize are valid numbers
                const validPage = Math.max(1, Number(page) || 1);
                const validPageSize = Math.min(100, Math.max(1, Number(pageSize) || 10));
                
                const response = yield call(fetchDefaultPeopleListItems, { 
                    page: validPage, 
                    pageSize: validPageSize 
                });
                
                yield put({
                    type: 'setDefaultPeopleListItems',
                    payload: response
                });

                if (callback) {
                    callback(response);
                }
            } catch (error) {
                console.error('Error fetching default people list items:', error);
                if (callback) {
                    callback({ items: [], pagination: { total: 0, page: 1, pageSize: 10 } });
                }
            }
        },
        *fetchPhoneForListPerson({ payload, callback }: any, { call }: any): Generator<any, void, any> {
            try {
                const response = yield call(fetchPhoneForListPerson, payload);
                
                if(response.phone_numbers?.length === 0) {
                    message.warning('No phone number found for this person');
                }

                if (callback) {
                    callback(response);
                }
            } catch (error) {
                console.error('Error fetching phone for list person:', error);
                if (callback) {
                    callback({ success: false, phone_numbers: [] });
                }
            }
        }
    },
    reducers: {
        setProductListItems(state: any, { payload }: any) {
            return {
                ...state,
                productLists: {
                    ...state.productLists,
                    [payload.id]: payload.items
                }
            };
        },
        setPeopleListItems(state: any, { payload }: any) {
            return {
                ...state,
                peopleLists: {
                    ...state.peopleLists,
                    [payload.id]: payload.items
                }
            };
        },
        setDefaultPeopleListItems(state: any, { payload }: any) {
            return {
                ...state,
                defaultPeopleList: payload
            };
        },
        initSelectedRows(state: any) {
            return {
                ...state,
                selectedRows: []
            };
        },
        addToSelectedRows(state: any, { payload }: any) {
            if (!state.selectedRows.includes(payload)) {
                return {
                    ...state,
                    selectedRows: [...state.selectedRows, payload]
                };
            }
            return state;
        },
        removeFromSelectedRows(state: any, { payload }: any) {
            return {
                ...state,
                selectedRows: state.selectedRows.filter((id: any) => id !== payload)
            };
        },
        clearSelectedRows(state: any) {
            return {
                ...state,
                selectedRows: []
            };
        }
    }
}

export default Model;